const getStateData = (state) => state?.auth?.data;

const getToken = (state) => getStateData(state)?.token;
const getUser = (state) => getStateData(state)?.user;
const getIsLoggedIn = (state) => getStateData(state)?.loggedIn;

const authSelectors = { getToken, getUser, getIsLoggedIn };
export default authSelectors;
